import { initContract } from '@ts-rest/core'
import { authContract } from './auth'
import { courierContract } from './courier'
import { deliveryContract } from './delivery'
import { orderContract } from './order'
import { paymentContract } from './payment'
import { productContract } from './product'
import { referralContract } from './referral'
import { subscriptionContract } from './subscription'
import { animalsContract } from './users/animal'
import { zendeskContract } from './zendesk'

export type { ErrorResponse } from './general'
export type { GetUserReferralsResponse, Referral, UpdateReferralCodeBody } from './referral'

const c = initContract()

export const contract = c.router({
  auth: authContract,
  courier: courierContract,
  delivery: deliveryContract,
  product: productContract,
  subscription: subscriptionContract,
  order: orderContract,
  payment: paymentContract,
  animals: animalsContract,
  referral: referralContract,
  zendesk: zendeskContract,
})

export {
  animalsContract,
  authContract,
  courierContract,
  deliveryContract,
  orderContract,
  paymentContract,
  productContract,
  referralContract,
  subscriptionContract,
  zendeskContract
}
